module.exports = __webpack_public_path__ + "static/media/talk-bubble-02.8670a22a.png";